export default __webpack_public_path__ + "static/media/guests.20785a92.svg";